export default "__VITE_ASSET__BOsxsnoC__"